export enum SettingEnum {
  TIER_RESET_TIME = "1",
}
